module.exports = __webpack_public_path__ + "icon-128-visualisation-donut.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-donut.png
// module id = 628
// module chunks = 11